export default __webpack_public_path__ + "static/media/dashBoardFilledIcon.03271998.svg";